'use client';

import { Route } from 'next';
import { useRouter } from 'next/navigation';
import ReactPaginate from 'react-paginate';
import styles from './Pagination.module.scss';
import FaIcon, { faChevronLeft, faChevronRight } from '../../icon/FaIcon/FaIcon';

type Props = {
  currentPage: number;
  total: number;
  perPage: number;
  lastPage: number;
  queryString?: string;
};

function Pagination({ currentPage, total, perPage, queryString = 'page' }: Props) {
  const router = useRouter();

  const changePage = (selectedItem: { selected: number }) => {
    // URLを書き換える
    const params = new URLSearchParams(location.search);
    params.set(queryString, String(selectedItem.selected + 1));
    router.push(`${location.pathname}?${params.toString()}` as Route);
  };

  const totalPageCount = Math.ceil(total / perPage);

  return (
    <>
      {totalPageCount > 0 && (
        <>
          <ReactPaginate
            breakLabel={'...'}
            nextLabel={<FaIcon icon={faChevronRight}></FaIcon>}
            previousLabel={<FaIcon icon={faChevronLeft}></FaIcon>}
            onPageChange={changePage}
            pageRangeDisplayed={3}
            marginPagesDisplayed={1}
            pageCount={totalPageCount}
            initialPage={currentPage - 1}
            disableInitialCallback={true}
            className={styles.pagination}
            pageClassName={styles.pageItem}
            pageLinkClassName={styles.pagelink}
            activeLinkClassName={styles.currentLink}
            breakClassName={styles.lastOmit}
            previousClassName={styles.pagePrev}
            nextClassName={styles.pageNext}
          />
        </>
      )}
    </>
  );
}

export default Pagination;
